import PageTitle from "../../../layout/PageTitle";
import React from "react";
import {Alert, Container, Tab, Tabs} from "react-bootstrap";
import ListTable from "../../shared/ListTable";
import {deleteItem} from "../../../helpers/Api";
import {AddButton, DeleteButton, EditButton} from "../../../helpers/ButtonHelper";
import {useMutation, useQuery} from "@apollo/client";
import {deleteMeasurementMutation, getMeasurementsQuery} from "./MeasurementQueries";
import MeasurementsChart from "./MeasurementsChart";
import Loader from "../../shared/Loader";

const MeasurementsList = () => {
  const { data, loading } = useQuery(getMeasurementsQuery)
  const [deleteCall] = useMutation(deleteMeasurementMutation, { refetchQueries: [getMeasurementsQuery] })

  const header = <tr>
    <th>Data</th>
    <th>Greutate</th>
    <th>Talie</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.formattedDate}</td>
      <td>{item.weight}</td>
      <td>{item.waist}</td>
      <td className='actions'>
        <EditButton to={`/my_measurements/${item.id}`} />
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)} />
      </td>
    </tr>
  }

  const Body = () => {
    if (loading) return <Loader />;

    return (
      <Tabs>
        <Tab title='Lista' eventKey='list'
             className='border p-3 border-top-0 bg-body rounded rounded-top-0 shadow pb-4'>
          <div className="row justify-content-md-center">
            <div className="page-container col">
              {data.measurements.length > 0
                ?
                <ListTable data={data.measurements} header={header} listItem={listItem}
                           searchFields={['formattedDate', 'weight', 'waist']} />
                :
                <Alert variant='warning'>Lista este goala</Alert>
              }
            </div>
          </div>
        </Tab>
        <Tab title='Grafic' eventKey='chart'
             className='border p-3 border-top-0 bg-body rounded rounded-top-0 shadow'>
          {data.measurements.length > 0 &&
            <div>
              <MeasurementsChart data={data.measurements} />
            </div>
          }
        </Tab>
      </Tabs>
    )
  }

  return (
    <Container>
      <PageTitle title='Masuratorile mele' buttons={
        <AddButton to='/my_measurements/new' />
      } />
      <Body />
    </Container>
  )
}

export default MeasurementsList;
